import CommentComposer from '@/components/Comment/CommentComposer';
import PostCommentFormHeader from '@/components/Comment/PostCommentFormHeader';
import { useCreateCommentMutation } from './comment.api.slice';

function PostCommentForm({ postId }: { postId: string }) {
  const [comment] = useCreateCommentMutation();

  return (
    <div className="w-full h-fit gap-4 flex flex-col">
      <PostCommentFormHeader />
      <CommentComposer
        onSubmit={async (body) => {
          await comment({ postId, comment: body }).unwrap();
        }}
      />
    </div>
  );
}

export default PostCommentForm;
